import { motion } from "framer-motion";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const CELLS = [
  {
    icon: Phone,
    label: "DIRECT LINE",
    value: "283-237-0359",
    sub: "Donald Broughton // Owner-Operator",
    href: "tel:2832370359",
    testid: "contact-phone",
  },
  {
    icon: Mail,
    label: "EMAIL COMMAND",
    value: "at-ease@operationfixit.net",
    sub: "Response within 24 hours",
    href: "mailto:at-ease@operationfixit.net",
    testid: "contact-email",
  },
  {
    icon: MapPin,
    label: "AREA OF OPERATIONS",
    value: "Northern Kentucky",
    sub: "Cincinnati Metropolitan Area",
    href: null,
    testid: "contact-area",
  },
  {
    icon: Clock,
    label: "HOURS OF OPERATION",
    value: "Mon–Fri // 0900–1700",
    sub: "Emergency hours & weekends available",
    href: null,
    testid: "contact-hours",
  },
];

export const ContactStrip = () => (
  <section id="contact" className="border-t border-olive-deep bg-olive-deep/20 py-24 sm:py-32" data-testid="contact-section">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
      <p className="overline-tactical text-coyote mb-4" data-testid="contact-overline">OP-FIX // 05 // DIRECT CONTACT</p>
      <h2 className="font-display uppercase text-4xl sm:text-6xl tracking-tight mb-4" data-testid="contact-heading">
        Reach <span className="text-khaki">Command</span>
      </h2>
      <p className="max-w-md text-sm text-muted-foreground leading-relaxed mb-14">
        Veteran owned and operated by Donald Broughton. Serving homeowners across
        Northern Kentucky and the Cincinnati metro — emergency and weekend calls available.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-olive-deep border border-olive-deep">
        {CELLS.map((c, i) => {
          const Icon = c.icon;
          const inner = (
            <>
              <div className="flex items-start justify-between">
                <Icon className="w-6 h-6 text-khaki group-hover:text-alert transition-colors duration-300" strokeWidth={1.5} />
                <span className="text-[9px] tracking-[0.3em] text-coyote">0{i + 1}</span>
              </div>
              <div className="mt-10">
                <span className="text-[9px] tracking-[0.3em] text-coyote">{c.label}</span>
                <div className="mt-1.5 text-sm sm:text-base font-bold text-foreground break-all">{c.value}</div>
                <div className="mt-1 text-[11px] text-muted-foreground">{c.sub}</div>
              </div>
            </>
          );
          const cls =
            "group bg-obsidian p-6 sm:p-8 min-h-[180px] flex flex-col justify-between hover:bg-olive-deep/60 transition-colors duration-300";
          return (
            <motion.div
              key={c.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
            >
              {c.href ? (
                <a href={c.href} className={cls} data-testid={c.testid}>{inner}</a>
              ) : (
                <div className={cls} data-testid={c.testid}>{inner}</div>
              )}
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
